<template>
  <div>
    <div>
      <div>{{ message }}</div>
      <div class="bio-progress">
        <div
          class="bio-progress-bar"
          :class="{ 'bio-progress-bar-warning': warning }"
          :style="barSize"
        />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    value: Number,
    max: Number,
    message: String,
    warning: Boolean,
  },

  computed: {
    barSize() {
      let size = (this.value / this.max) * 100
      size = size.toFixed(2)

      return {width: size + '%'}
    },
  },
}
</script>

<style lang="scss" scoped>
.bio-progress {
  background-color: $light-grey;
  height: 3em;
  margin-top: 0.25em;
}
.bio-progress-bar {
  background-color: $green;
  height: 3em;
  transition: all 1.5s ease;

  &-warning {
    background-color: $red;
  }
}
</style>
